export { default } from "/opt/build/repo/web/src/components/blocks/SignupBlock/index.js"